import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { GroupContainer, GroupHeader, PermissionList } from './styles';
import PermissionItem from './PermissionItem';
import { StyledButton } from '../../components/Header/styles';
import { PlusOutlined } from "@ant-design/icons";
import { UserPermissionConfig } from '../../redux/features/user/types';
import { Skeleton } from 'antd';


interface PermissionGroupProps {
    group: {
        key: string;
        label: string;
        configType: string;
        configuration: UserPermissionConfig[];
    };
    onEditPermission: (permission: UserPermissionConfig) => void;
    onDeletePermission: (id: string) => void;
    onAddPermission: (configType: number) => void;
    loading: boolean;
}

const PermissionGroup: React.FC<PermissionGroupProps> = ({
    group,
    onEditPermission,
    onDeletePermission,
    onAddPermission,
    loading
}) => {
    return (
        <GroupContainer>
            <GroupHeader>
                {group.label}
                <StyledButton
                    type='link'
                    icon={<PlusOutlined />}
                    onClick={() => onAddPermission(Number(group.configType))}
                    disabled={loading}
                />
            </GroupHeader>
            {loading ? (
                <PermissionList>
                    {[1, 2, 3].map((item) => (
                        <div key={item} style={{ padding: '10px', marginBottom: '10px' }}>
                            <Skeleton active paragraph={{ rows: 1 }} />
                        </div>
                    ))}
                </PermissionList>
            ) : (
                <Droppable droppableId={group.key}>
                    {(provided, snapshot) => (
                        <PermissionList
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            {group.configuration.map((permission, index) => (
                                <Draggable
                                    key={permission.id}
                                    draggableId={permission.id}
                                    index={index}
                                >
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                                ...provided.draggableProps.style,
                                                opacity: snapshot.isDragging ? 0.5 : 1,
                                            }}
                                        >
                                            <PermissionItem
                                                permission={permission}
                                                onEdit={() => onEditPermission(permission)}
                                                onDelete={onDeletePermission}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </PermissionList>
                    )}
                </Droppable>
            )}
        </GroupContainer>
    );
};

export default PermissionGroup; 